<template lang="pug">
div
  div
    button.back(v-if="origin == 'balance_sheet'" @click="$router.push({ name: 'dashboard', params: { isPrincipalPath: false } })")
      vm-icon(icon="arrow-back-outline" size="2rem")
    button.back(v-else @click="$router.push({ name: 'administrative_concepts' })")
      vm-icon(icon="arrow-back-outline" size="2rem")
  div.dashboard
    div.header
    div.title
      h2.title_item {{ $t('strings.administrative_summary') }}
      img#icon(src="@/assets/lapiz.png")
    div.administrative_statistics
      div.main_statistic
        div.side_color(style="background-color: #e0e0e0")
        div(style="padding-bottom: 1rem")
          h3#name {{ administrativeConcept.concept }}
          img.name_icon(src="@/assets/lapiz.png")
      div.statistic_row
        div.statistic
          div.side_color(style="background-color: #a5170f")
          span.statistic_text {{ $t('administratives_dashboard.income')}}
          strong.statistic_number {{ administrativeConcept.income | currency }}
        div.statistic
          div.side_color(style="background-color: #049856")
          span.statistic_text  {{ $t('administratives_dashboard.expenses')}}
          strong.statistic_number {{ administrativeConcept.charges  | currency }}
        div.statistic
          div.side_color(style="background-color: #bb8700")
          span.statistic_text {{ $t('administratives_dashboard.utility')}}
          strong.statistic_number {{ administrativeConcept.utility | currency }}
    br
    h2 {{ $t('administratives_dashboard.income') }} / {{ $t('administratives_dashboard.expenses') }}
    br
    AdministrativeConcepts(@updateScoreCard="reloadStatistics")
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('AdministrativeConcepts')
export default {
  components: {
    AdministrativeConcepts: () => import('@/components/dashboard/administratives/AdministrativeConcepts.vue')
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    currentPage: 1,
    date: '',
    currentId: null,
    origin: null
  }),
  computed: {
    ...mapGetters([
      'administrativeConcept'
    ])
  },
  async created () {
    await this.loadRecord({ id: this.$route.params.id })
    this.origin = this.$route.params.origin
  },
  methods: {
    ...mapActions([
      'loadRecord'
    ]),
    async reloadStatistics () {
      setTimeout(async () => {
        await this.loadRecord({ id: this.$route.params.id })
      }, 500)
    }
  }
}
</script>
<style scoped lang="scss">
@import '../components/dashboard/administratives/administrative_dashboard_structure.css';
.dashboard {
  background-color: #fafafa;
  padding: 0 5rem 0 5rem;
}
.container {
  margin-bottom: 1rem;
}
.tabs-container {
  display: flex;
}
.tabs-item {
  padding: 0.5rem;
  margin-right: 1rem;
  text-align: left;
  cursor: pointer;
}
.tabs-item-active,
.tabs-item:hover {
  border-bottom: solid 0.3rem rgb(180, 3, 3);
  border-radius: 0.18rem;
}
#name {
  padding: 1rem 1rem 1rem 0;
  float: right;
  font-size: 1.3vw;
  display: block;
  height: 8rem;
  width: 11vw;
}
.name_icon {
  width: 3vw;
  float: left;
  margin: 1vw 0 1vw 1vw;
}

</style>
